import React from 'react';
import axios from 'axios';

class ActivationHandler extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
    }

    componentDidMount() {
        const query = new URLSearchParams(this.props.location.search);
        const key = query.get('key');

        if (!key) {
            window.location.href = '/auth-server/registrationNotOk';
            return;
        }

        axios
            .get(`/auth-server/api/auth/activate?key=${key}`)
            .then((response) => {
                if (response.status === 200) {
                    const odaAdi = encodeURIComponent(response.data); // Güvenli URL için encode et
                    window.location.href = `/auth-server/registrationOk?oda=${odaAdi}`;
                } else {
                    window.location.href = '/auth-server/registrationNotOk';
                }
            })
            .catch(() => {
                window.location.href = '/auth-server/registrationNotOk';
            });
    }

    render() {
        return (
            <div>
                <h2>Hesabınız doğrulanıyor...</h2>
            </div>
        );
    }
}

export default ActivationHandler;


// WEBPACK FOOTER //
// ./src/page/signup/ActivationHandler.js